export const nl = {
    instructionHeader: 'Wat kost mijn bril op sterkte?',
    instructionHeaderMultifocalTemplate:
        'Wat kost mijn multifocale bril op sterkte?',
    instructionBody:
        'Bij Pearle hebben we heldere glaspakketten voor je samengesteld: Bronze, Silver, Gold, Diamond en Platinum. Zo zie je meteen welke glazen je wilt en wat ze kosten. Geen verrassingen dus.',
    single: 'Enkelvoudig',
    multifocal: 'Multifocaal',
    storeOnly: 'Alleen in de winkels',
    overview: 'Overzicht',
    discount: 'Gratis montuur',
    included: 'inbegrepen',
    glassesPackage: 'glaspakket',
    frame: 'Montuur',
    glassesPrice: 'Brilprijs',
    topChoice: 'Meest gekozen',
    youPay: 'Totaalprijs',
    errorFetching: 'Er is een fout opgetreden bij het ophalen van de gegevens',
    tooltipText: 'Niet beschikbaar bij dit montuur',
    extraOption: 'Wil je een extra optie toevoegen?',
    footer: 'Let op: je kunt online een bril bestellen met diverse glaspakketten en glasopties, maar niet alle extra glasopties zijn mogelijk bij een online bestelling. Vragen? <1>Neem contact met ons op</1>.',
};
